import { action } from 'satcheljs/lib/legacy';
import {
    CreateAttachmentHandler,
    ComposeUniqueState,
    FileSelectionFilter,
    lazyAttachmentFilePicker,
} from 'owa-attachment-filepicker';
import { fetchUploadFolder, getUploadFolder } from 'owa-attachments-upload-folder';
import {
    lazyGetAvailableLocalAttachmentSize,
    AttachmentWellViewState,
} from 'owa-attachment-well-data';

export default action('openFilePickerAndAttach')(async function openFilePickerAndAttach(
    isInline: boolean,
    isOnGroupCalendar: boolean,
    handler: CreateAttachmentHandler,
    attachmentWell: AttachmentWellViewState,
    targetWindow: Window
) {
    // TODO: Save the event draft

    const maximumClassicAttachmentSize = (await lazyGetAvailableLocalAttachmentSize.import())(
        attachmentWell
    );
    let uploadFolder = getUploadFolder();
    if (!uploadFolder) {
        uploadFolder = await fetchUploadFolder();
    }

    lazyAttachmentFilePicker.importAndExecute(handler, null /* insertLinkHandler */, {
        fileSelectionFilter: isInline ? FileSelectionFilter.Images : FileSelectionFilter.None,
        maxAllowedLocalFilesSize: maximumClassicAttachmentSize,
        supportsInsertLink: false,
        uploadConfiguration: {
            folderName: uploadFolder.folderName ? uploadFolder.folderName : null,
            composeUniqueState: isOnGroupCalendar
                ? ComposeUniqueState.GroupCalendar
                : ComposeUniqueState.None,
        },
        targetWindow: targetWindow,
    });
});
